import React from 'react';
import { ExternalLink, Newspaper } from 'lucide-react';
interface Article {
  title: string;
  publication: string;
  url: string;
}
const articles: Article[] = [{
  publication: 'TechBullion',
  title: 'Architecting Trust at Scale: How Arthur Miller is Reimagining Financial Infrastructure',
  url: 'https://techbullion.com/architecting-trust-at-scale-how-arthur-miller-is-reimagining-financial-infrastructure/'
}, {
  publication: 'Stars of Entrepreneurship',
  title: 'Arthur Miller Brings FiQIS to Market with Transparency and Stakeholder Engagement',
  url: 'https://starsofentrepreneurship.com/arthur-miller-brings-fiqis-to-market-with-transparency-and-stakeholder-engagement/'
}, {
  publication: 'SD Weekly',
  title: "Arthur Miller's FiQIS Tackles the Hidden Costs of Legacy Banking Infrastructure",
  url: 'https://sdweekly.com/arthur-millers-fiqis-tackles-the-hidden-costs-of-legacy-banking-infrastructure/'
}, {
  publication: 'Belmont Star',
  title: "Arthur Miller's FiQIS Integrates Post-Quantum Encryption Before Launch",
  url: 'https://belmontstar.com/arthur-millers-fiqis-integrates-post-quantum-encryption-before-launch/'
}, {
  publication: 'Markets Herald',
  title: 'Arthur Miller Designed FiQIS as Modular Infrastructure for Diverse Banking Needs',
  url: 'https://marketsherald.com/arthur-miller-designed-fiqis-as-modular-infrastructure-for-diverse-banking-needs/'
}, {
  publication: 'Ritz Herald',
  title: "Servant Leadership in High-Tech Environments: Arthur Miller's Blueprint",
  url: 'https://ritzherald.com/servant-leadership-in-high-tech-environments-arthur-millers-blueprint/'
}, {
  publication: 'Yahoo Finance',
  title: 'Beyond BNPL: Building Smarter Credit Systems',
  url: 'https://finance.yahoo.com/news/beyond-bnpl-building-smarter-credit-222500750.html'
}, {
  publication: 'USA Wire',
  title: 'Arthur Miller on Ethical Innovation: Balancing AI, Security, and Human Impact',
  url: 'https://usawire.com/arthur-miller-on-ethical-innovation-balancing-ai-security-and-human-impact/'
}, {
  publication: 'CEO Weekly',
  title: 'Arthur Miller on Building Financial Systems People Can Trust',
  url: 'https://ceoweekly.com/arthur-miller-on-building-financial-systems-people-can-trust/'
}, {
  publication: 'NY Weekly',
  title: 'The Post-Quantum Banking Era: Preparing Financial Systems for What Comes Next',
  url: 'https://nyweekly.com/business/the-post-quantum-banking-era-preparing-financial-systems-for-what-comes-next/'
}, {
  publication: 'Business Insider',
  title: 'Beyond BNPL: Building Smarter Credit Systems for the Next Decade',
  url: 'https://markets.businessinsider.com/news/stocks/beyond-bnpl-building-smarter-credit-systems-for-the-next-decade-with-arthur-miller-1035208141'
}, {
  publication: 'AP News',
  title: 'Building Smarter Credit Systems for the Next Decade with Arthur Miller',
  url: 'https://apnews.com/press-release/access-newswire/beyond-bnpl-building-smarter-credit-systems-for-the-next-decade-with-arthur-miller-476db6f3d8abb0254fda05dc11b0f24e'
}];
export function ArticlesGrid() {
  return <section id="articles" className="py-24 bg-slate-50 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-22">
      {/* Decorative background elements */}
      <div className="absolute top-10 right-10 text-blue-100 opacity-30" data-id="element-23">
        <Newspaper className="h-32 w-32" data-id="element-24" />
      </div>
      <div className="absolute bottom-10 left-10 text-slate-200 opacity-30" data-id="element-25">
        <Newspaper className="h-24 w-24" data-id="element-26" />
      </div>

      <div className="max-w-7xl mx-auto relative" data-id="element-27">
        <div className="text-center mb-16" data-id="element-28">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-2xl mb-4" data-id="element-29">
            <Newspaper className="h-8 w-8 text-blue-600" data-id="element-30" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-31">
            Featured In
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-600 to-cyan-500 mx-auto rounded-full mb-6" data-id="element-32"></div>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-33">
            Insights, interviews, and thought leadership across major financial
            and technology publications.
          </p>
        </div>

        {/* Stats bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12 max-w-4xl mx-auto" data-id="element-34">
          <div className="bg-white rounded-xl p-4 text-center border border-slate-100 shadow-sm" data-id="element-35">
            <div className="text-3xl font-bold text-blue-600 mb-1" data-id="element-36">
              {articles.length}+
            </div>
            <div className="text-sm text-slate-600" data-id="element-37">Publications</div>
          </div>
          <div className="bg-white rounded-xl p-4 text-center border border-slate-100 shadow-sm" data-id="element-38">
            <div className="text-3xl font-bold text-emerald-600 mb-1" data-id="element-39">10+</div>
            <div className="text-sm text-slate-600" data-id="element-40">Major Outlets</div>
          </div>
          <div className="bg-white rounded-xl p-4 text-center border border-slate-100 shadow-sm" data-id="element-41">
            <div className="text-3xl font-bold text-purple-600 mb-1" data-id="element-42">2026</div>
            <div className="text-sm text-slate-600" data-id="element-43">Recent Year</div>
          </div>
          <div className="bg-white rounded-xl p-4 text-center border border-slate-100 shadow-sm" data-id="element-44">
            <div className="text-3xl font-bold text-orange-600 mb-1" data-id="element-45">100%</div>
            <div className="text-sm text-slate-600" data-id="element-46">Thought Leader</div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-47">
          {articles.map((article, index) => <a key={index} href={article.url} target="_blank" rel="noopener noreferrer" className="group block bg-white rounded-xl p-6 shadow-sm hover:shadow-lg border border-slate-100 hover:border-blue-200 transition-all duration-300 flex flex-col h-full hover:-translate-y-1" data-id="element-48">
              <div className="flex items-center justify-between mb-4" data-id="element-49">
                <span className="text-sm font-bold text-blue-600 uppercase tracking-wider group-hover:text-blue-700" data-id="element-50">
                  {article.publication}
                </span>
                <div className="w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center group-hover:bg-blue-100 transition-colors" data-id="element-51">
                  <ExternalLink className="h-4 w-4 text-blue-600 group-hover:scale-110 transition-transform" data-id="element-52" />
                </div>
              </div>
              <h3 className="text-lg font-semibold text-slate-900 group-hover:text-blue-700 transition-colors leading-snug flex-grow" data-id="element-53">
                {article.title}
              </h3>
              <div className="mt-4 pt-4 border-t border-slate-100" data-id="element-54">
                <span className="text-sm text-slate-500 group-hover:text-blue-600 transition-colors font-medium" data-id="element-55">
                  Read article →
                </span>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}